import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        min-width: 1585px;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        background-color: ${({ theme }) => theme.color.white};
    `,
    "ContentWrapper": styled.div`
        display: flex;
        flex-grow: 1;
    `
}